// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import EditorController from "./editor_controller"
application.register("editor", EditorController)

import FormSubmitController from "./form_submit_controller"
application.register("form-submit", FormSubmitController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import PaypalController from "./paypal_controller"
application.register("paypal", PaypalController)

import PaypalRegistrationController from "./paypal_registration_controller"
application.register("paypal-registration", PaypalRegistrationController)

import PaypalSearchController from "./paypal_search_controller"
application.register("paypal-search", PaypalSearchController)

import RefundController from "./refund_controller"
application.register("refund", RefundController)

import SearchSuggestController from "./search_suggest_controller"
application.register("search-suggest", SearchSuggestController)
